import PropTypes from 'prop-types';
import { Card, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import QuillEditor from 'src/components/quill-editor';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import ZoomImages from 'src/components/zoom-images';

export const DetailView = ({ item }) => {
  return (
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={3}>
          <Grid container spacing={3} xs={12} md={6}>
            {item.ticket && (
                <Grid xs={12} md={12} display="flex" justifyContent="center">
                  <Typography
                    color="error.main"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      textAlign: 'center',
                    }}>
                    {item.ticket.reason} 
                  </Typography>
                </Grid>
            )}

            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Ngày nhận xe" value={item.checkinSys} />
            </Grid>

            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Ngày trả xe" value={item.checkoutSys} />
            </Grid>

            <Grid xs={12} md={6}>
              <ReadOnlyTextField
                enumType='decimal'
                label="Km lúc nhận"
                value={item.checkinKm}
              />
            </Grid>

            <Grid xs={12} md={6}>
              <ReadOnlyTextField
                enumType='decimal'
                label="Km lúc trả"
                value={item.checkoutKm}
              />
            </Grid>

            <Grid xs={12}>
              <ReadOnlyTextField label="Xe" value={item.car?.name} />
            </Grid>

            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Người nhận" value={item.contact?.name} />
            </Grid>

            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Số điện thoại" value={item.contact?.phone} enumType='phone' />
            </Grid>

            <Grid xs={12} md={6}>
              <ReadOnlyTextField
                dateFormat={'dd/MM/yyyy - HH:mm'}
                label="Giờ xe ra"
                value={item.checkinBy}
              />
            </Grid>

            <Grid xs={12} md={6}>
              <ReadOnlyTextField
                dateFormat={'dd/MM/yyyy - HH:mm'}
                label="Giờ xe về"
                value={item.checkoutBy}
              />
            </Grid>

            <Grid xs={12}>
              <QuillEditor
                value={item.note}
                isReadOnly={true}
              />
            </Grid>
          </Grid>
          {/* Right */}
          <Grid xs={12} md={6}>
            <Grid
              container
              spacing={2}
              sx={{
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                //height: '100%', // Ensure it takes the full height of the parent
              }}
            >
              {item.evidences?.map((img, index) => (
                <Grid item="true" key={index}>
                  <ZoomImages
                    item={img}
                    imgArray={item.evidences}
                    checked={img?.thumb ?? false}
                    height="72"
                    frame="144px"
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

DetailView.propTypes = {
  item: PropTypes.object.isRequired,
};
